import httpService from "../../Service/httpService";

const controller = "Catalogos";

export const getAcceso = async (idNegocio, idUser, idModulo) => {
	const res = await httpService.get(`/${controller}/getAcceso/${idNegocio}/${idUser}/${idModulo}`);
	return res.data;
}

export const getCatDiagnosticos = async (filtro) => {
	const res = await httpService.get(`/${controller}/getCatDiagnosticos/${filtro}`);
	return res.data;
}

export const getGruposLab = async (id) => {
	const res = await httpService.get(`/${controller}/getGruposLab/${id}`);
	return res.data;
}

export const getListServicios = async (id) => {
	const res = await httpService.get(`/${controller}/getListServicios/${id}`);
	return res.data;
}

export const getMarcadoresLab = async (id, idGpo) => {
	const res = await httpService.get(`/${controller}/getMarcadoresLab/${id}/${idGpo}`);
	return res.data;
}

export const getListMarcadoresLab = async (id) => {
	const res = await httpService.get(`/${controller}/getListMarcadoresLab/${id}`);
	return res.data;
}

export const getNaciones = async () => {
	const res = await httpService.get(`/${controller}/getNaciones`);
	return res.data;
}

export const getEntidades = async () => {
	const res = await httpService.get(`/${controller}/getEstados`);
	return res.data;
}

export const getMunicipios = async (idEntidad) => {
	const res = await httpService.get(`/${controller}/getMunicipios/${idEntidad}`);
	return res.data;
}

export const getFormaciones = async () => {
	const res = await httpService.get(`/${controller}/getFormaciones`);
	return res.data;
}

export const getReligiones = async () => {
	const res = await httpService.get(`/${controller}/getReligiones`);
	return res.data;
}

export const getRegimenFiscal = async (rfc) => {
	const res = await httpService.get(`/${controller}/getRegimenFiscal/${rfc}`);
	return res.data;
}

export const updateServicio = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/updateServicio`, {
		...data,
	});
	return res;
};
